<div class="row pt-4 px-2">
  <div class="row w-100">
    <div class="col-1 pl-3 text-center pb-2">
      <img src="assets/svg/ico-floor.svg" class="icon" />
    </div>
    <div class="col-6 pl-3">
      <div class="col-12 heading">
        <app-with-tooltip [showHelpCursor]="true">{{ name }}</app-with-tooltip>
      </div>
    </div>
    <div class="col-5 text-right text pb-3 d-flex justify-content-end pr-3">
      <app-with-tooltip
        class="overflow-ellipsis pr-2"
        [showHelpCursor]="true"
        >{{
          wingName ? wingName + " - " + ("WING" | translate) : ""
        }}</app-with-tooltip
      >

      <!-- dynamic element render -->
      <ng-content select="[cornerElement]"></ng-content>
    </div>
  </div>
</div>
